import type { Dictionary } from "./types";

export const en: Dictionary = {
  nav: { about: "About", services: "Services", method: "How we work", locations: "Locations", contact: "Contact" },
  hero: {
    title: "Artificial intelligence, woven into your business.",
    subtitle:
      "TUXIA is an innovative software house: we design cloud platforms and AI solutions that turn complex business needs into simple, scalable digital tools.",
    cta: "Get in touch",
  },
  about: {
    heading: "About us",
    badge: "Innovative startup",
    body: "Founded in 2026, TUXIA S.R.L. is an innovative startup based in the Veneto region of Italy. We build high-value technology software with a strong focus on integrating AI into business workflows — favouring evolutive, replicable and integrable products over one-off custom projects.",
    foundedLabel: "year of founding",
  },
  services: {
    heading: "What we do",
    items: [
      { title: "AI Integration", description: "AI-powered systems: LLMs, RAG, machine learning, NLP and computer vision integrated into your processes." },
      { title: "Cloud Platforms", description: "Scalable, secure cloud software platforms delivered as SaaS and PaaS." },
      { title: "Data & Analytics", description: "Data analysis, big data management and data mining to extract value from your data." },
      { title: "Process Automation", description: "Business process automation (RPA) and predictive analytics for greater efficiency." },
      { title: "Cybersecurity", description: "Advanced security and integrity protection for data and AI models." },
    ],
  },
  method: {
    heading: "How we work",
    intro: "An iterative, transparent process built around your actual business needs.",
    steps: [
      {
        number: "01",
        title: "Discovery",
        description: "We listen and analyse: understanding your context, existing workflows and business goals before writing a single line of code.",
      },
      {
        number: "02",
        title: "Design",
        description: "We define architecture, tech stack and roadmap. Every technical choice is driven by concrete requirements, not current trends.",
      },
      {
        number: "03",
        title: "Development",
        description: "Short, iterative cycles: frequent releases, continuous feedback, verified quality. The product grows in a controlled, measurable way.",
      },
      {
        number: "04",
        title: "Evolution",
        description: "Software doesn't end at go-live. We monitor, optimise and evolve the product together with you over time.",
      },
    ],
  },
  locations: {
    heading: "Locations",
    registeredLabel: "Registered office",
    operationalLabel: "Operational office",
    mapsCta: "Open in Maps",
  },
  contact: {
    heading: "Contact",
    body: "Have a project or a question? Write to us and we'll get back to you soon.",
    cta: "Email us",
  },
  footer: {
    statusLabel: "Innovative startup",
    vatLabel: "VAT / Tax code",
    reaLabel: "REA",
    capitalLabel: "Share capital",
    registeredOfficeLabel: "Registered office",
    privacyLabel: "Privacy Policy",
    termsLabel: "Terms of Service",
    rights: "All rights reserved.",
  },
};
